<script setup>
import { useI18n } from 'vue-i18n'
import { useForm } from '@inertiajs/vue3'
import AppLayout from '@/Layouts/AppLayout.vue'
import PageShell from '@/Components/UI/PageShell.vue'
import SettingsTabs from '@/Components/UI/SettingsTabs.vue'
import UiInput from '@/Components/UI/UiInput.vue'
import UiTextarea from '@/Components/UI/UiTextarea.vue'
import UiButton from '@/Components/UI/UiButton.vue'
import StickyActionBar from '@/Components/UI/StickyActionBar.vue'

defineOptions({ layout: AppLayout })

const { t } = useI18n()

const props = defineProps({
  quick_reply: { type: Object, required: true },
  errors:      { type: Object, default: () => ({}) },
})

const form = useForm({
  label: props.quick_reply.label || '',
  body:  props.quick_reply.body  || '',
})

const submit = () => {
  if (props.quick_reply.id) {
    form.transform((d) => ({ quick_reply: d })).patch(`/quick_replies/${props.quick_reply.id}`)
  } else {
    form.transform((d) => ({ quick_reply: d })).post('/quick_replies')
  }
}
</script>

<template>
  <PageShell
    :title="t('quickReplies.title')"
    narrow
    back-href="/quick_replies"
  >
    <template #breadcrumb>
      <SettingsTabs />
    </template>

    <form
      id="quick-reply-form"
      class="space-y-4"
      @submit.prevent="submit"
    >
      <div>
        <label class="block text-xs text-[color:var(--muted)] mb-1">{{ t('quickReplies.label') }}</label>
        <UiInput
          v-model="form.label"
          :error="errors.label || form.errors.label"
        />
      </div>
      <div>
        <label class="block text-xs text-[color:var(--muted)] mb-1">{{ t('quickReplies.body') }}</label>
        <UiTextarea
          v-model="form.body"
          :rows="4"
          :error="errors.body || form.errors.body"
        />
      </div>
    </form>

    <StickyActionBar>
      <UiButton
        type="submit"
        form="quick-reply-form"
        variant="primary"
        :loading="form.processing"
      >
        {{ t('settings.save') }}
      </UiButton>
    </StickyActionBar>
  </PageShell>
</template>
